// @react
import React, { ReactElement } from 'react'
// @libraries
import DocumentTitle from 'react-document-title'
// @components
import TopicsContainer from 'modules/onBoarding/components/Topics'

const Topics = (): ReactElement => {
  return (
    <DocumentTitle title={`Step 7 - Follow Your Topic | ATD`}>
      <>
        <TopicsContainer />
      </>
    </DocumentTitle>
  )
}

export default Topics
